import React,{useEffect} from "react";
import {Link } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';
import check from "../images/check.png";
const Php_Development = () =>
{

return(
<>
<div className="web-page">
  <section className="">
    <div className="container px-0">
      <div className="row  xs-column-reverse  align-items-stretch">
        <div className="col-md-6 align-self-center ">
          <div className="techUse-title ">
            <h1><span className="sub-color">PHP </span>Development</h1>
          </div>
          <p>At BFC Softtech, we have a standard PHP development process that must be followed for every project, irrespective of its magnitude. </p>
          <Link to="/contact" className="btn btn-s">
          Let's Talk
          </Link>
        </div>
        <div className="col-md-6">
          <img src="../assets/img/solutions/php.jpg" alt="" srcset="" className="img-fluid" />
        </div>
      </div>
    </div>
  </section>
  <section className="work-process py-5">
    <div className="container px-0">
      <div className="row">
        <div className="col-md-12">
          <div className="techUse-title text-center">
            <h1>Our <span className="sub-color"> PHP
              </span> Development Process 
            </h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          <img src="../assets/img/solutions/IT Process.png" className="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="py-lg-5">
    <div className="container px-0">
      <div className="row justify-content-center pt-4">
        <div className="col-md-12 text-center">
          <div className="techUse-title text-center">
            <h1>Benefits of Hiring a <span className="sub-color"> PHP
              Development </span> Company 
            </h1>
          </div>
          <p className="short-desc">Here are 5 reasons why hiring a PHP Development Company can benefit your business. </p>
        </div>
      </div>
    <div className="row why-go pb-4">
        <div className="col-md-4 ml-3 ba">
          <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Expertise and Experience </h4>
            <p>
            They're a team of experienced professionals familiar with the latest PHP frameworks and technologies. Consequently, they are adept at developing robust, scalable, and efficient web applications.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Cost-Effectiveness</h4>
            <p>
            Hiring a PHP Development Company is a cost-effective option for businesses, as they don't have to worry about the costs of hiring and training an in-house development team. 
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Customized Solutions</h4>
            <p>
            A PHP Development Company can help you with customized solutions tailored to your needs. They have the expertise needed to create websites and applications that meet industry standards, enhancing your business's profitability. 
            </p>
          </div>
          </span>
        </div>
        </div>
        <div className="row why-go justify-content-center">
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Quality Assurance </h4>
            <p>
            A professional PHP Development Company subjects its products to thorough testing, ensuring that its apps and websites are free of bugs and perform like they're expected to, saving their clients a lot of money and hassles. 
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Continuous Support and Maintenance </h4>
            <p>
            They provide ongoing support and maintenance services, ensuring that the web applications and websites they develop continue to function efficiently.
            </p>
          </div>
          </span>
        </div>
       
      </div>
    </div>
  </section>
  <section>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="techUse-title text-center">
            <h1>  Why Choose <span className="sub-color">BFC Softtech</span> as your <span className="sub-color"> PHP
              Development </span> Company? 
            </h1>
          </div>
        </div>
        <div className="col-md-8 text-center ">
          <p className="short-desc">At BFC Softtech, we understand that every business has unique requirements. As a result, we ensure that your website or application is not only functional but also reflects your brand value. </p>
        </div>
      </div>
      <div className="row py-5">
        <section className="web-banner mb-4">
          <Carousel>
            <Carousel.Item >
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/dev.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title pt-3">
                            <h4 className="color-bluec">Agile Methodology </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">We have an agile approach towards PHP development that helps us quickly adapt to your changing requirements and develop flexible solutions. This means we adjust our approach as needed, ensuring that your website/application is completed on time and within budget.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/new/security.png" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Security and Data Protection
                            </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">We take security and data protection seriously. Our developers follow best the practices for security and encryption to protect your website or application and the data it contains.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/expert.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Strong Communication
                            </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">At BFC Softtech, we prioritize communication. We keep our clients informed throughout the development process, providing regular updates and progress reports. Also, we are always open to any feedbacks, ready and willing to make any necessary adjustments as and when needed.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </section>
      </div>
    </div>
  </section>
 
</div>
</>
)
}
export default Php_Development